module.exports = __webpack_public_path__ + "img/ico_maleta-medico.9d48333f.svg";